import { useCallback, useEffect, useRef } from 'react'

import window from 'common/window'

import { IUseKeyUpListener, useKeyUpListener } from './use-key-up-listener'

export const useKeyUpWhileOpen = (open: boolean, listeners: IUseKeyUpListener) => {
  const listener = useKeyUpListener(listeners)
  const lastOpen = useRef(false)

  const listen = useCallback(() => {
    window.addEventListener('keyup', listener)
    lastOpen.current = true
  }, [listener])

  const unlisten = useCallback(() => {
    window.removeEventListener('keyup', listener)
    lastOpen.current = false
  }, [listener])

  useEffect(() => {
    if (open && !lastOpen.current) {
      listen()
    } else if (!open && lastOpen.current) {
      unlisten()
    }
    return () => {
      if (lastOpen.current) {
        unlisten()
      }
    }
  }, [open, listen, unlisten])
}
